<script lang="ts">
  import SvelteTable, { type Column } from "../lib/SvelteTable.svelte";
  import PCell from "../components/cells/PCell.svelte";
  import type { SnapshotOrderItem } from "../helpers/types";
  import { formatPriceFromCents } from "../helpers/currency";

  export let orderItems: SnapshotOrderItem[];

  const COLUMNS: Record<string, Column<any>> = {
    product_name: {
      key: "product-name",
      width: 12,
      title: "product name",
      value: (v: SnapshotOrderItem) => {
        return v.name;
      },
      renderComponent: {
        component: PCell,
        propsf(v: SnapshotOrderItem) {
          return {
            contents: this.value!(v),
          };
        },
      },
    },
    reference: {
      key: "reference",
      width: 6,
      title: "reference",
      value: (v: SnapshotOrderItem) => {
        return v.supplier_product_reference ?? "";
      },
      renderComponent: {
        component: PCell,
        propsf(v: SnapshotOrderItem) {
          return {
            contents: this.value!(v),
          };
        },
      },
    },
    unit: {
      key: "unit",
      width: 6,
      title: "unit",
      value: (v: SnapshotOrderItem) => {
        return v.unit;
      },
      renderComponent: {
        component: PCell,
        propsf(v: SnapshotOrderItem) {
          return {
            contents: this.value!(v),
          };
        },
      },
    },
    price: {
      key: "price",
      width: 6,
      title: "price",
      value: (v: SnapshotOrderItem) => {
        if (v.price === 0) {
          return "-";
        }

        return formatPriceFromCents(v.price);
      },
      renderComponent: {
        component: PCell,
        propsf(v: SnapshotOrderItem) {
          return {
            contents: this.value!(v),
          };
        },
      },
    },
    quantity: {
      key: "quantity",
      width: 6,
      title: "quantity",
      value: (v: SnapshotOrderItem) => {
        return v.quantity;
      },
      renderComponent: {
        component: PCell,
        propsf(v: SnapshotOrderItem) {
          return {
            contents: this.value!(v),
          };
        },
      },
    },
  };

  $: cols = Object.values(COLUMNS);
</script>

<div class="container">
  <div class="table">
    <SvelteTable
      {...{
        columns: cols,
        rows: orderItems,
      }}
      classNameRow="transaction-row button"
      classNameTable="transactions-table"
      classNameCell="order-product-cell"
    />
  </div>
</div>

<style>
  .container {
    display: flex;
    flex: 0;
    flex-direction: column;
    background-color: white;
  }

  .loading-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 75vh;
  }

  .table {
    display: flex;
    flex: 1;
    height: 100vh;
    overflow: auto;
    flex-direction: column;
    border-radius: 8px;
    border: solid 1px #ebebeb;
    border-top: 0;
  }
</style>
